module.exports = __webpack_public_path__ + "static/img/hover13.0723a2bf.png";